import styled from "styled-components";

export const GaugeWrapper = styled.div`
  margin-bottom: 20px;
`;
